module.exports = __webpack_public_path__ + "img/sharetips.701611ab.png";